var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14286 1.00002H3V3.35717H4.14286H20.1428H21.2857V1.00002H20.1428H4.14286ZM12.9762 7.65895L12.1428 6.74555L11.3095 7.65895L5.21428 14.3375L4.43333 15.192L6.1 16.8076L6.88095 15.9482L11 11.4353V15.5357V21.8214V23H13.2857V21.8214V15.5357V11.4353L17.4047 15.9482L18.1905 16.8076L19.8571 15.192L19.0762 14.3326L12.9809 7.65404L12.9762 7.65895Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.d445b43614879b15b8f2a424e748844d.svg";
export { ForwardRef as ReactComponent };